function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect } from 'react';
import Decimal from 'decimal.js';
import { Controller, useFormContext } from 'react-hook-form';
import DiscountTextField from "../../DiscountTextField";
import { DiscountModel, DiscountType } from "../../../models";
import { utils } from "../../../utils";
import { connectControllerToDiscountTextField } from "../../../utils/react-hook-form.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export default function DiscountInput(_ref) {
  let {
    onChange: _onChange = () => {},
    testid
  } = _ref;
  const {
    control,
    watch,
    trigger,
    getValues
  } = useFormContext();
  const [pricing, price, minPrice, billingTrigger, oneTimeInStagesBilling, discountType] = watch(['pricing', 'price', 'minPrice', 'trigger', 'oneTimeInStagesBilling', 'discount.type']);
  useEffect(() => {
    trigger('discount');
  }, [pricing, price, minPrice, billingTrigger, oneTimeInStagesBilling]);
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "discount",
    rules: {
      validate: _ref2 => {
        let {
          type,
          amount
        } = _ref2;
        const {
          pricing,
          price,
          minPrice,
          oneTimeInStagesBilling
        } = getValues();
        if (+amount < 0) {
          return 'Insert a non-negative discount';
        }
        const errorMsg = 'The discount cannot be greater than the price';
        if (price && utils.applyDiscount(new Decimal(+price), DiscountModel.make(type, +amount)).lessThan(0)) return errorMsg;
        if (pricing === 'range' && minPrice && utils.applyDiscount(new Decimal(+minPrice), DiscountModel.make(type, +amount)).lessThan(0)) return errorMsg;
        if (!!oneTimeInStagesBilling && type !== DiscountType.Percent) return 'Must be a percentage when billing in stages';
      }
    },
    render: p => {
      const connectedProps = connectControllerToDiscountTextField(p, {
        alwaysShowErrors: true
      });
      return /*#__PURE__*/_jsx(DiscountTextField, _objectSpread(_objectSpread({
        alwaysShrinkLabel: true,
        label: discountType === DiscountType.Percent ? 'Discount' : 'Unit discount',
        "data-testid": testid
      }, connectedProps), {}, {
        onChange: value => {
          _onChange(value);
          connectedProps.onChange(value);
        },
        isBillInStages: !!oneTimeInStagesBilling
      }));
    }
  });
}